import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { WpapiService } from 'src/app/services/wpapi.service';

@Component({
    selector: 'app-connect',
    templateUrl: './connect.component.html',
    styleUrls: ['./connect.component.scss']
})
export class ConnectComponent implements OnInit, OnDestroy {
    connectData;
    socials;
    interval;
    loadGallery: boolean = false;
    loadContentTitle: boolean = false;
    loadContentParagraph: boolean = false;
    loadContentExcerpt: boolean = false;
    loadContentExcerptMobile: boolean = false;
    loadEmailsTitle: boolean = false;
    loadEmails: boolean = false;
    loadSocials1: boolean = false;
    loadSocials2: boolean = false;
    loadSocials3: boolean = false;
    loadSocials4: boolean = false;
    loadSocials5: boolean = false;
    loadTitle: boolean = false;
    activeImage: number = 0;
    activeMobileImage: number = 0;
    screenWidth: number = 0;


    constructor(private wpApi: WpapiService) {
        this.wpApi.getContactInfo().subscribe(resp => {
            this.connectData = resp[0].acf;
        })
        this.wpApi.getSocialMenu().subscribe(resp => {
            this.socials = resp.items;
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.screenWidth = window.innerWidth;
    }

    ngOnInit(): void {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth > 1024) {
            this.interval = setInterval(() => {
                this.nextImage();
            }, 4000);
        } else {
            this.interval = setInterval(() => {
                this.nextMobileImage();
            }, 4000);
        }
    }

    ngOnDestroy(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    loadedImage() {
        if (this.screenWidth > 1024) {
            setTimeout(() => {
                this.loadGallery = true
            }, 100);
            setTimeout(() => {
                this.loadContentTitle = true
            }, 400);
            setTimeout(() => {
                this.loadContentParagraph = true
            }, 500);
            setTimeout(() => {
                this.loadContentExcerpt = true
            }, 600);
            setTimeout(() => {
                this.loadEmailsTitle = true
            }, 700);
            setTimeout(() => {
                this.loadEmails = true
            }, 900);
            setTimeout(() => {
                this.loadSocials1 = true
            }, 1000);
            setTimeout(() => {
                this.loadSocials2 = true
            }, 1100);
            setTimeout(() => {
                this.loadSocials3 = true
            }, 1200);
            setTimeout(() => {
                this.loadSocials4 = true
            }, 1300);
            setTimeout(() => {
                this.loadSocials5 = true
            }, 1400);
        } else {
            setTimeout(() => {
                this.loadGallery = true
            }, 100);
            setTimeout(() => {
                this.loadTitle = true
            }, 200);
            setTimeout(() => {
                this.loadEmailsTitle = true
            }, 300);
            setTimeout(() => {
                this.loadEmails = true
            }, 500);
            setTimeout(() => {
                this.loadSocials1 = true
            }, 600);
            setTimeout(() => {
                this.loadSocials2 = true
            }, 700);
            setTimeout(() => {
                this.loadSocials3 = true
            }, 800);
            setTimeout(() => {
                this.loadSocials4 = true
            }, 900);
            setTimeout(() => {
                this.loadSocials5 = true
            }, 1000);
            setTimeout(() => {
                this.loadContentExcerptMobile = true
            }, 1100);
        }
    }

    nextImage() {
        this.activeImage = this.randomNumber(0, this.connectData.gallery.length - 1)
    }

    nextMobileImage() {
        this.activeMobileImage = this.randomNumber(0, this.connectData.mobile_gallery.length - 1)
    }

    randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
}
